// frontend/packs/application.js

/* eslint-disable import/first, import/newline-after-import */

import(/* webpackChunkName: "ez-styles" */ 'styleguide');
import 'init';

/* global */
import 'global/application-component.css';
import 'layouts/page/page';
import 'components/global/site-footer/site-footer';

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import ApplicationController from 'components/global/application/application-controller';
EezyStimulusApplication.register('application', ApplicationController);

import SiteFooterController from 'components/global/site-footer/site-footer-controller';
EezyStimulusApplication.register('site-footer', SiteFooterController);

import './application-imports/tracking-tests';

import './application-imports/site-header';

import './application-imports/banners-nags';

import './application-imports/sessions';

import './application-imports/search';

import './application-imports/promos-popups';

import './application-imports/grids';

import './application-imports/collections-utils';

import './application-imports/misc-utils';
